var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.buttonClassOpts({ skeleton: true }),attrs:{"disabled":"","type":"button"}})
}
var staticRenderFns = []

export { render, staticRenderFns }